import { render, staticRenderFns } from "./deleteDict.vue?vue&type=template&id=6f6314f6&scoped=true"
import script from "./deleteDict.vue?vue&type=script&lang=js"
export * from "./deleteDict.vue?vue&type=script&lang=js"
import style0 from "./deleteDict.vue?vue&type=style&index=0&id=6f6314f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6314f6",
  null
  
)

export default component.exports